import { j as l } from "./jsx-runtime-B6kdoens.js";
import nt, { useMemo as me, useRef as Ae, useReducer as ot, useEffect as We, useCallback as Z, forwardRef as it, useImperativeHandle as at, Fragment as ct } from "react";
import { g as st } from "./_commonjsHelpers-DaMA6jEr.js";
import { c as fe, a as ye } from "./index-CROKJrb5.js";
import { c as tr, f as nr } from "./create-component-CBAeEoQ6.js";
import { u as ut } from "./use-unique-id-BA9hSqap.js";
import { Typography as ve } from "./react/Typography/index.js";
import { M as lt } from "./motion-jk0ivqSc.js";
import { IconRenderer as ft } from "./react/Icon/index.js";
import { A as pt } from "./index-LYq8AemS.js";
import { m as dt } from "./motion-minimal-Crg_qVxv.js";
import { UploadIcon as or } from "./react/Icon/icons/UploadIcon/index.js";
import { ArrowLeftIcon as mt } from "./react/Icon/icons/ArrowLeftIcon/index.js";
import { UnknownProgress as vt, Progress as yt, useUnknownProgressValue as gt } from "./react/Progress/index.js";
import { CheckmarkIcon as bt } from "./react/Icon/icons/CheckmarkIcon/index.js";
import { ErrorIcon as Fr } from "./react/Icon/icons/ErrorIcon/index.js";
import { getAspectRatioClasses as ht, Image as xt } from "./react/Image/index.js";
import { Squeeze as Et } from "./react/Squeeze/index.js";
import { FaceIcon as wt } from "./react/Icon/icons/FaceIcon/index.js";
var Je = { exports: {} }, De = { exports: {} }, _ = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ur;
function jt() {
  if (ur) return _;
  ur = 1;
  var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, c = e ? Symbol.for("react.context") : 60110, v = e ? Symbol.for("react.async_mode") : 60111, f = e ? Symbol.for("react.concurrent_mode") : 60111, y = e ? Symbol.for("react.forward_ref") : 60112, h = e ? Symbol.for("react.suspense") : 60113, C = e ? Symbol.for("react.suspense_list") : 60120, R = e ? Symbol.for("react.memo") : 60115, $ = e ? Symbol.for("react.lazy") : 60116, D = e ? Symbol.for("react.block") : 60121, N = e ? Symbol.for("react.fundamental") : 60117, K = e ? Symbol.for("react.responder") : 60118, te = e ? Symbol.for("react.scope") : 60119;
  function z(p) {
    if (typeof p == "object" && p !== null) {
      var X = p.$$typeof;
      switch (X) {
        case r:
          switch (p = p.type, p) {
            case v:
            case f:
            case n:
            case o:
            case i:
            case h:
              return p;
            default:
              switch (p = p && p.$$typeof, p) {
                case c:
                case y:
                case $:
                case R:
                case s:
                  return p;
                default:
                  return X;
              }
          }
        case t:
          return X;
      }
    }
  }
  function M(p) {
    return z(p) === f;
  }
  return _.AsyncMode = v, _.ConcurrentMode = f, _.ContextConsumer = c, _.ContextProvider = s, _.Element = r, _.ForwardRef = y, _.Fragment = n, _.Lazy = $, _.Memo = R, _.Portal = t, _.Profiler = o, _.StrictMode = i, _.Suspense = h, _.isAsyncMode = function(p) {
    return M(p) || z(p) === v;
  }, _.isConcurrentMode = M, _.isContextConsumer = function(p) {
    return z(p) === c;
  }, _.isContextProvider = function(p) {
    return z(p) === s;
  }, _.isElement = function(p) {
    return typeof p == "object" && p !== null && p.$$typeof === r;
  }, _.isForwardRef = function(p) {
    return z(p) === y;
  }, _.isFragment = function(p) {
    return z(p) === n;
  }, _.isLazy = function(p) {
    return z(p) === $;
  }, _.isMemo = function(p) {
    return z(p) === R;
  }, _.isPortal = function(p) {
    return z(p) === t;
  }, _.isProfiler = function(p) {
    return z(p) === o;
  }, _.isStrictMode = function(p) {
    return z(p) === i;
  }, _.isSuspense = function(p) {
    return z(p) === h;
  }, _.isValidElementType = function(p) {
    return typeof p == "string" || typeof p == "function" || p === n || p === f || p === o || p === i || p === h || p === C || typeof p == "object" && p !== null && (p.$$typeof === $ || p.$$typeof === R || p.$$typeof === s || p.$$typeof === c || p.$$typeof === y || p.$$typeof === N || p.$$typeof === K || p.$$typeof === te || p.$$typeof === D);
  }, _.typeOf = z, _;
}
var P = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var lr;
function Tt() {
  return lr || (lr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, c = e ? Symbol.for("react.context") : 60110, v = e ? Symbol.for("react.async_mode") : 60111, f = e ? Symbol.for("react.concurrent_mode") : 60111, y = e ? Symbol.for("react.forward_ref") : 60112, h = e ? Symbol.for("react.suspense") : 60113, C = e ? Symbol.for("react.suspense_list") : 60120, R = e ? Symbol.for("react.memo") : 60115, $ = e ? Symbol.for("react.lazy") : 60116, D = e ? Symbol.for("react.block") : 60121, N = e ? Symbol.for("react.fundamental") : 60117, K = e ? Symbol.for("react.responder") : 60118, te = e ? Symbol.for("react.scope") : 60119;
    function z(u) {
      return typeof u == "string" || typeof u == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      u === n || u === f || u === o || u === i || u === h || u === C || typeof u == "object" && u !== null && (u.$$typeof === $ || u.$$typeof === R || u.$$typeof === s || u.$$typeof === c || u.$$typeof === y || u.$$typeof === N || u.$$typeof === K || u.$$typeof === te || u.$$typeof === D);
    }
    function M(u) {
      if (typeof u == "object" && u !== null) {
        var G = u.$$typeof;
        switch (G) {
          case r:
            var ue = u.type;
            switch (ue) {
              case v:
              case f:
              case n:
              case o:
              case i:
              case h:
                return ue;
              default:
                var he = ue && ue.$$typeof;
                switch (he) {
                  case c:
                  case y:
                  case $:
                  case R:
                  case s:
                    return he;
                  default:
                    return G;
                }
            }
          case t:
            return G;
        }
      }
    }
    var p = v, X = f, Y = c, ie = s, Q = r, ee = y, ae = n, ce = $, ne = R, I = t, q = o, V = i, B = h, re = !1;
    function L(u) {
      return re || (re = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), a(u) || M(u) === v;
    }
    function a(u) {
      return M(u) === f;
    }
    function m(u) {
      return M(u) === c;
    }
    function E(u) {
      return M(u) === s;
    }
    function w(u) {
      return typeof u == "object" && u !== null && u.$$typeof === r;
    }
    function b(u) {
      return M(u) === y;
    }
    function O(u) {
      return M(u) === n;
    }
    function x(u) {
      return M(u) === $;
    }
    function j(u) {
      return M(u) === R;
    }
    function S(u) {
      return M(u) === t;
    }
    function A(u) {
      return M(u) === o;
    }
    function T(u) {
      return M(u) === i;
    }
    function W(u) {
      return M(u) === h;
    }
    P.AsyncMode = p, P.ConcurrentMode = X, P.ContextConsumer = Y, P.ContextProvider = ie, P.Element = Q, P.ForwardRef = ee, P.Fragment = ae, P.Lazy = ce, P.Memo = ne, P.Portal = I, P.Profiler = q, P.StrictMode = V, P.Suspense = B, P.isAsyncMode = L, P.isConcurrentMode = a, P.isContextConsumer = m, P.isContextProvider = E, P.isElement = w, P.isForwardRef = b, P.isFragment = O, P.isLazy = x, P.isMemo = j, P.isPortal = S, P.isProfiler = A, P.isStrictMode = T, P.isSuspense = W, P.isValidElementType = z, P.typeOf = M;
  }()), P;
}
var fr;
function Rr() {
  return fr || (fr = 1, process.env.NODE_ENV === "production" ? De.exports = jt() : De.exports = Tt()), De.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Ye, pr;
function Ot() {
  if (pr) return Ye;
  pr = 1;
  var e = Object.getOwnPropertySymbols, r = Object.prototype.hasOwnProperty, t = Object.prototype.propertyIsEnumerable;
  function n(o) {
    if (o == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(o);
  }
  function i() {
    try {
      if (!Object.assign)
        return !1;
      var o = new String("abc");
      if (o[5] = "de", Object.getOwnPropertyNames(o)[0] === "5")
        return !1;
      for (var s = {}, c = 0; c < 10; c++)
        s["_" + String.fromCharCode(c)] = c;
      var v = Object.getOwnPropertyNames(s).map(function(y) {
        return s[y];
      });
      if (v.join("") !== "0123456789")
        return !1;
      var f = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(y) {
        f[y] = y;
      }), Object.keys(Object.assign({}, f)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Ye = i() ? Object.assign : function(o, s) {
    for (var c, v = n(o), f, y = 1; y < arguments.length; y++) {
      c = Object(arguments[y]);
      for (var h in c)
        r.call(c, h) && (v[h] = c[h]);
      if (e) {
        f = e(c);
        for (var C = 0; C < f.length; C++)
          t.call(c, f[C]) && (v[f[C]] = c[f[C]]);
      }
    }
    return v;
  }, Ye;
}
var qe, dr;
function ir() {
  if (dr) return qe;
  dr = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return qe = e, qe;
}
var Be, mr;
function Ir() {
  return mr || (mr = 1, Be = Function.call.bind(Object.prototype.hasOwnProperty)), Be;
}
var Ke, vr;
function St() {
  if (vr) return Ke;
  vr = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var r = ir(), t = {}, n = Ir();
    e = function(o) {
      var s = "Warning: " + o;
      typeof console < "u" && console.error(s);
      try {
        throw new Error(s);
      } catch {
      }
    };
  }
  function i(o, s, c, v, f) {
    if (process.env.NODE_ENV !== "production") {
      for (var y in o)
        if (n(o, y)) {
          var h;
          try {
            if (typeof o[y] != "function") {
              var C = Error(
                (v || "React class") + ": " + c + " type `" + y + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[y] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw C.name = "Invariant Violation", C;
            }
            h = o[y](s, y, v, c, null, r);
          } catch ($) {
            h = $;
          }
          if (h && !(h instanceof Error) && e(
            (v || "React class") + ": type specification of " + c + " `" + y + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof h + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), h instanceof Error && !(h.message in t)) {
            t[h.message] = !0;
            var R = f ? f() : "";
            e(
              "Failed " + c + " type: " + h.message + (R ?? "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (t = {});
  }, Ke = i, Ke;
}
var He, yr;
function At() {
  if (yr) return He;
  yr = 1;
  var e = Rr(), r = Ot(), t = ir(), n = Ir(), i = St(), o = function() {
  };
  process.env.NODE_ENV !== "production" && (o = function(c) {
    var v = "Warning: " + c;
    typeof console < "u" && console.error(v);
    try {
      throw new Error(v);
    } catch {
    }
  });
  function s() {
    return null;
  }
  return He = function(c, v) {
    var f = typeof Symbol == "function" && Symbol.iterator, y = "@@iterator";
    function h(a) {
      var m = a && (f && a[f] || a[y]);
      if (typeof m == "function")
        return m;
    }
    var C = "<<anonymous>>", R = {
      array: K("array"),
      bigint: K("bigint"),
      bool: K("boolean"),
      func: K("function"),
      number: K("number"),
      object: K("object"),
      string: K("string"),
      symbol: K("symbol"),
      any: te(),
      arrayOf: z,
      element: M(),
      elementType: p(),
      instanceOf: X,
      node: ee(),
      objectOf: ie,
      oneOf: Y,
      oneOfType: Q,
      shape: ce,
      exact: ne
    };
    function $(a, m) {
      return a === m ? a !== 0 || 1 / a === 1 / m : a !== a && m !== m;
    }
    function D(a, m) {
      this.message = a, this.data = m && typeof m == "object" ? m : {}, this.stack = "";
    }
    D.prototype = Error.prototype;
    function N(a) {
      if (process.env.NODE_ENV !== "production")
        var m = {}, E = 0;
      function w(O, x, j, S, A, T, W) {
        if (S = S || C, T = T || j, W !== t) {
          if (v) {
            var u = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw u.name = "Invariant Violation", u;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var G = S + ":" + j;
            !m[G] && // Avoid spamming the console because they are often not actionable except for lib authors
            E < 3 && (o(
              "You are manually calling a React.PropTypes validation function for the `" + T + "` prop on `" + S + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), m[G] = !0, E++);
          }
        }
        return x[j] == null ? O ? x[j] === null ? new D("The " + A + " `" + T + "` is marked as required " + ("in `" + S + "`, but its value is `null`.")) : new D("The " + A + " `" + T + "` is marked as required in " + ("`" + S + "`, but its value is `undefined`.")) : null : a(x, j, S, A, T);
      }
      var b = w.bind(null, !1);
      return b.isRequired = w.bind(null, !0), b;
    }
    function K(a) {
      function m(E, w, b, O, x, j) {
        var S = E[w], A = V(S);
        if (A !== a) {
          var T = B(S);
          return new D(
            "Invalid " + O + " `" + x + "` of type " + ("`" + T + "` supplied to `" + b + "`, expected ") + ("`" + a + "`."),
            { expectedType: a }
          );
        }
        return null;
      }
      return N(m);
    }
    function te() {
      return N(s);
    }
    function z(a) {
      function m(E, w, b, O, x) {
        if (typeof a != "function")
          return new D("Property `" + x + "` of component `" + b + "` has invalid PropType notation inside arrayOf.");
        var j = E[w];
        if (!Array.isArray(j)) {
          var S = V(j);
          return new D("Invalid " + O + " `" + x + "` of type " + ("`" + S + "` supplied to `" + b + "`, expected an array."));
        }
        for (var A = 0; A < j.length; A++) {
          var T = a(j, A, b, O, x + "[" + A + "]", t);
          if (T instanceof Error)
            return T;
        }
        return null;
      }
      return N(m);
    }
    function M() {
      function a(m, E, w, b, O) {
        var x = m[E];
        if (!c(x)) {
          var j = V(x);
          return new D("Invalid " + b + " `" + O + "` of type " + ("`" + j + "` supplied to `" + w + "`, expected a single ReactElement."));
        }
        return null;
      }
      return N(a);
    }
    function p() {
      function a(m, E, w, b, O) {
        var x = m[E];
        if (!e.isValidElementType(x)) {
          var j = V(x);
          return new D("Invalid " + b + " `" + O + "` of type " + ("`" + j + "` supplied to `" + w + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return N(a);
    }
    function X(a) {
      function m(E, w, b, O, x) {
        if (!(E[w] instanceof a)) {
          var j = a.name || C, S = L(E[w]);
          return new D("Invalid " + O + " `" + x + "` of type " + ("`" + S + "` supplied to `" + b + "`, expected ") + ("instance of `" + j + "`."));
        }
        return null;
      }
      return N(m);
    }
    function Y(a) {
      if (!Array.isArray(a))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? o(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : o("Invalid argument supplied to oneOf, expected an array.")), s;
      function m(E, w, b, O, x) {
        for (var j = E[w], S = 0; S < a.length; S++)
          if ($(j, a[S]))
            return null;
        var A = JSON.stringify(a, function(W, u) {
          var G = B(u);
          return G === "symbol" ? String(u) : u;
        });
        return new D("Invalid " + O + " `" + x + "` of value `" + String(j) + "` " + ("supplied to `" + b + "`, expected one of " + A + "."));
      }
      return N(m);
    }
    function ie(a) {
      function m(E, w, b, O, x) {
        if (typeof a != "function")
          return new D("Property `" + x + "` of component `" + b + "` has invalid PropType notation inside objectOf.");
        var j = E[w], S = V(j);
        if (S !== "object")
          return new D("Invalid " + O + " `" + x + "` of type " + ("`" + S + "` supplied to `" + b + "`, expected an object."));
        for (var A in j)
          if (n(j, A)) {
            var T = a(j, A, b, O, x + "." + A, t);
            if (T instanceof Error)
              return T;
          }
        return null;
      }
      return N(m);
    }
    function Q(a) {
      if (!Array.isArray(a))
        return process.env.NODE_ENV !== "production" && o("Invalid argument supplied to oneOfType, expected an instance of array."), s;
      for (var m = 0; m < a.length; m++) {
        var E = a[m];
        if (typeof E != "function")
          return o(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + re(E) + " at index " + m + "."
          ), s;
      }
      function w(b, O, x, j, S) {
        for (var A = [], T = 0; T < a.length; T++) {
          var W = a[T], u = W(b, O, x, j, S, t);
          if (u == null)
            return null;
          u.data && n(u.data, "expectedType") && A.push(u.data.expectedType);
        }
        var G = A.length > 0 ? ", expected one of type [" + A.join(", ") + "]" : "";
        return new D("Invalid " + j + " `" + S + "` supplied to " + ("`" + x + "`" + G + "."));
      }
      return N(w);
    }
    function ee() {
      function a(m, E, w, b, O) {
        return I(m[E]) ? null : new D("Invalid " + b + " `" + O + "` supplied to " + ("`" + w + "`, expected a ReactNode."));
      }
      return N(a);
    }
    function ae(a, m, E, w, b) {
      return new D(
        (a || "React class") + ": " + m + " type `" + E + "." + w + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + b + "`."
      );
    }
    function ce(a) {
      function m(E, w, b, O, x) {
        var j = E[w], S = V(j);
        if (S !== "object")
          return new D("Invalid " + O + " `" + x + "` of type `" + S + "` " + ("supplied to `" + b + "`, expected `object`."));
        for (var A in a) {
          var T = a[A];
          if (typeof T != "function")
            return ae(b, O, x, A, B(T));
          var W = T(j, A, b, O, x + "." + A, t);
          if (W)
            return W;
        }
        return null;
      }
      return N(m);
    }
    function ne(a) {
      function m(E, w, b, O, x) {
        var j = E[w], S = V(j);
        if (S !== "object")
          return new D("Invalid " + O + " `" + x + "` of type `" + S + "` " + ("supplied to `" + b + "`, expected `object`."));
        var A = r({}, E[w], a);
        for (var T in A) {
          var W = a[T];
          if (n(a, T) && typeof W != "function")
            return ae(b, O, x, T, B(W));
          if (!W)
            return new D(
              "Invalid " + O + " `" + x + "` key `" + T + "` supplied to `" + b + "`.\nBad object: " + JSON.stringify(E[w], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(a), null, "  ")
            );
          var u = W(j, T, b, O, x + "." + T, t);
          if (u)
            return u;
        }
        return null;
      }
      return N(m);
    }
    function I(a) {
      switch (typeof a) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !a;
        case "object":
          if (Array.isArray(a))
            return a.every(I);
          if (a === null || c(a))
            return !0;
          var m = h(a);
          if (m) {
            var E = m.call(a), w;
            if (m !== a.entries) {
              for (; !(w = E.next()).done; )
                if (!I(w.value))
                  return !1;
            } else
              for (; !(w = E.next()).done; ) {
                var b = w.value;
                if (b && !I(b[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function q(a, m) {
      return a === "symbol" ? !0 : m ? m["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && m instanceof Symbol : !1;
    }
    function V(a) {
      var m = typeof a;
      return Array.isArray(a) ? "array" : a instanceof RegExp ? "object" : q(m, a) ? "symbol" : m;
    }
    function B(a) {
      if (typeof a > "u" || a === null)
        return "" + a;
      var m = V(a);
      if (m === "object") {
        if (a instanceof Date)
          return "date";
        if (a instanceof RegExp)
          return "regexp";
      }
      return m;
    }
    function re(a) {
      var m = B(a);
      switch (m) {
        case "array":
        case "object":
          return "an " + m;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + m;
        default:
          return m;
      }
    }
    function L(a) {
      return !a.constructor || !a.constructor.name ? C : a.constructor.name;
    }
    return R.checkPropTypes = i, R.resetWarningCache = i.resetWarningCache, R.PropTypes = R, R;
  }, He;
}
var Ve, gr;
function Dt() {
  if (gr) return Ve;
  gr = 1;
  var e = ir();
  function r() {
  }
  function t() {
  }
  return t.resetWarningCache = r, Ve = function() {
    function n(s, c, v, f, y, h) {
      if (h !== e) {
        var C = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw C.name = "Invariant Violation", C;
      }
    }
    n.isRequired = n;
    function i() {
      return n;
    }
    var o = {
      array: n,
      bigint: n,
      bool: n,
      func: n,
      number: n,
      object: n,
      string: n,
      symbol: n,
      any: n,
      arrayOf: i,
      element: n,
      elementType: n,
      instanceOf: i,
      node: n,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: t,
      resetWarningCache: r
    };
    return o.PropTypes = o, o;
  }, Ve;
}
if (process.env.NODE_ENV !== "production") {
  var _t = Rr(), Pt = !0;
  Je.exports = At()(_t.isElement, Pt);
} else
  Je.exports = Dt()();
var Ct = Je.exports;
const F = /* @__PURE__ */ st(Ct);
function ge(e, r, t, n) {
  function i(o) {
    return o instanceof t ? o : new t(function(s) {
      s(o);
    });
  }
  return new (t || (t = Promise))(function(o, s) {
    function c(y) {
      try {
        f(n.next(y));
      } catch (h) {
        s(h);
      }
    }
    function v(y) {
      try {
        f(n.throw(y));
      } catch (h) {
        s(h);
      }
    }
    function f(y) {
      y.done ? o(y.value) : i(y.value).then(c, v);
    }
    f((n = n.apply(e, r || [])).next());
  });
}
function be(e, r) {
  var t = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, s;
  return s = { next: c(0), throw: c(1), return: c(2) }, typeof Symbol == "function" && (s[Symbol.iterator] = function() {
    return this;
  }), s;
  function c(f) {
    return function(y) {
      return v([f, y]);
    };
  }
  function v(f) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; s && (s = 0, f[0] && (t = 0)), t; ) try {
      if (n = 1, i && (o = f[0] & 2 ? i.return : f[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, f[1])).done) return o;
      switch (i = 0, o && (f = [f[0] & 2, o.value]), f[0]) {
        case 0:
        case 1:
          o = f;
          break;
        case 4:
          return t.label++, { value: f[1], done: !1 };
        case 5:
          t.label++, i = f[1], f = [0];
          continue;
        case 7:
          f = t.ops.pop(), t.trys.pop();
          continue;
        default:
          if (o = t.trys, !(o = o.length > 0 && o[o.length - 1]) && (f[0] === 6 || f[0] === 2)) {
            t = 0;
            continue;
          }
          if (f[0] === 3 && (!o || f[1] > o[0] && f[1] < o[3])) {
            t.label = f[1];
            break;
          }
          if (f[0] === 6 && t.label < o[1]) {
            t.label = o[1], o = f;
            break;
          }
          if (o && t.label < o[2]) {
            t.label = o[2], t.ops.push(f);
            break;
          }
          o[2] && t.ops.pop(), t.trys.pop();
          continue;
      }
      f = r.call(e, t);
    } catch (y) {
      f = [6, y], i = 0;
    } finally {
      n = o = 0;
    }
    if (f[0] & 5) throw f[1];
    return { value: f[0] ? f[1] : void 0, done: !0 };
  }
}
function br(e, r) {
  var t = typeof Symbol == "function" && e[Symbol.iterator];
  if (!t) return e;
  var n = t.call(e), i, o = [], s;
  try {
    for (; (r === void 0 || r-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (c) {
    s = { error: c };
  } finally {
    try {
      i && !i.done && (t = n.return) && t.call(n);
    } finally {
      if (s) throw s.error;
    }
  }
  return o;
}
function hr(e, r, t) {
  if (t || arguments.length === 2) for (var n = 0, i = r.length, o; n < i; n++)
    (o || !(n in r)) && (o || (o = Array.prototype.slice.call(r, 0, n)), o[n] = r[n]);
  return e.concat(o || Array.prototype.slice.call(r));
}
var Ft = /* @__PURE__ */ new Map([
  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
  ["aac", "audio/aac"],
  ["abw", "application/x-abiword"],
  ["arc", "application/x-freearc"],
  ["avif", "image/avif"],
  ["avi", "video/x-msvideo"],
  ["azw", "application/vnd.amazon.ebook"],
  ["bin", "application/octet-stream"],
  ["bmp", "image/bmp"],
  ["bz", "application/x-bzip"],
  ["bz2", "application/x-bzip2"],
  ["cda", "application/x-cdf"],
  ["csh", "application/x-csh"],
  ["css", "text/css"],
  ["csv", "text/csv"],
  ["doc", "application/msword"],
  ["docx", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"],
  ["eot", "application/vnd.ms-fontobject"],
  ["epub", "application/epub+zip"],
  ["gz", "application/gzip"],
  ["gif", "image/gif"],
  ["heic", "image/heic"],
  ["heif", "image/heif"],
  ["htm", "text/html"],
  ["html", "text/html"],
  ["ico", "image/vnd.microsoft.icon"],
  ["ics", "text/calendar"],
  ["jar", "application/java-archive"],
  ["jpeg", "image/jpeg"],
  ["jpg", "image/jpeg"],
  ["js", "text/javascript"],
  ["json", "application/json"],
  ["jsonld", "application/ld+json"],
  ["mid", "audio/midi"],
  ["midi", "audio/midi"],
  ["mjs", "text/javascript"],
  ["mp3", "audio/mpeg"],
  ["mp4", "video/mp4"],
  ["mpeg", "video/mpeg"],
  ["mpkg", "application/vnd.apple.installer+xml"],
  ["odp", "application/vnd.oasis.opendocument.presentation"],
  ["ods", "application/vnd.oasis.opendocument.spreadsheet"],
  ["odt", "application/vnd.oasis.opendocument.text"],
  ["oga", "audio/ogg"],
  ["ogv", "video/ogg"],
  ["ogx", "application/ogg"],
  ["opus", "audio/opus"],
  ["otf", "font/otf"],
  ["png", "image/png"],
  ["pdf", "application/pdf"],
  ["php", "application/x-httpd-php"],
  ["ppt", "application/vnd.ms-powerpoint"],
  ["pptx", "application/vnd.openxmlformats-officedocument.presentationml.presentation"],
  ["rar", "application/vnd.rar"],
  ["rtf", "application/rtf"],
  ["sh", "application/x-sh"],
  ["svg", "image/svg+xml"],
  ["swf", "application/x-shockwave-flash"],
  ["tar", "application/x-tar"],
  ["tif", "image/tiff"],
  ["tiff", "image/tiff"],
  ["ts", "video/mp2t"],
  ["ttf", "font/ttf"],
  ["txt", "text/plain"],
  ["vsd", "application/vnd.visio"],
  ["wav", "audio/wav"],
  ["weba", "audio/webm"],
  ["webm", "video/webm"],
  ["webp", "image/webp"],
  ["woff", "font/woff"],
  ["woff2", "font/woff2"],
  ["xhtml", "application/xhtml+xml"],
  ["xls", "application/vnd.ms-excel"],
  ["xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
  ["xml", "application/xml"],
  ["xul", "application/vnd.mozilla.xul+xml"],
  ["zip", "application/zip"],
  ["7z", "application/x-7z-compressed"],
  // Others
  ["mkv", "video/x-matroska"],
  ["mov", "video/quicktime"],
  ["msg", "application/vnd.ms-outlook"]
]);
function je(e, r) {
  var t = Rt(e);
  if (typeof t.path != "string") {
    var n = e.webkitRelativePath;
    Object.defineProperty(t, "path", {
      value: typeof r == "string" ? r : typeof n == "string" && n.length > 0 ? n : e.name,
      writable: !1,
      configurable: !1,
      enumerable: !0
    });
  }
  return t;
}
function Rt(e) {
  var r = e.name, t = r && r.lastIndexOf(".") !== -1;
  if (t && !e.type) {
    var n = r.split(".").pop().toLowerCase(), i = Ft.get(n);
    i && Object.defineProperty(e, "type", {
      value: i,
      writable: !1,
      configurable: !1,
      enumerable: !0
    });
  }
  return e;
}
var It = [
  // Thumbnail cache files for macOS and Windows
  ".DS_Store",
  "Thumbs.db"
  // Windows
];
function zt(e) {
  return ge(this, void 0, void 0, function() {
    return be(this, function(r) {
      return Pe(e) && Mt(e.dataTransfer) ? [2, Ut(e.dataTransfer, e.type)] : kt(e) ? [2, $t(e)] : Array.isArray(e) && e.every(function(t) {
        return "getFile" in t && typeof t.getFile == "function";
      }) ? [2, Nt(e)] : [2, []];
    });
  });
}
function Mt(e) {
  return Pe(e);
}
function kt(e) {
  return Pe(e) && Pe(e.target);
}
function Pe(e) {
  return typeof e == "object" && e !== null;
}
function $t(e) {
  return Xe(e.target.files).map(function(r) {
    return je(r);
  });
}
function Nt(e) {
  return ge(this, void 0, void 0, function() {
    var r;
    return be(this, function(t) {
      switch (t.label) {
        case 0:
          return [4, Promise.all(e.map(function(n) {
            return n.getFile();
          }))];
        case 1:
          return r = t.sent(), [2, r.map(function(n) {
            return je(n);
          })];
      }
    });
  });
}
function Ut(e, r) {
  return ge(this, void 0, void 0, function() {
    var t, n;
    return be(this, function(i) {
      switch (i.label) {
        case 0:
          return e.items ? (t = Xe(e.items).filter(function(o) {
            return o.kind === "file";
          }), r !== "drop" ? [2, t] : [4, Promise.all(t.map(Lt))]) : [3, 2];
        case 1:
          return n = i.sent(), [2, xr(zr(n))];
        case 2:
          return [2, xr(Xe(e.files).map(function(o) {
            return je(o);
          }))];
      }
    });
  });
}
function xr(e) {
  return e.filter(function(r) {
    return It.indexOf(r.name) === -1;
  });
}
function Xe(e) {
  if (e === null)
    return [];
  for (var r = [], t = 0; t < e.length; t++) {
    var n = e[t];
    r.push(n);
  }
  return r;
}
function Lt(e) {
  if (typeof e.webkitGetAsEntry != "function")
    return Er(e);
  var r = e.webkitGetAsEntry();
  return r && r.isDirectory ? Mr(r) : Er(e);
}
function zr(e) {
  return e.reduce(function(r, t) {
    return hr(hr([], br(r), !1), br(Array.isArray(t) ? zr(t) : [t]), !1);
  }, []);
}
function Er(e) {
  var r = e.getAsFile();
  if (!r)
    return Promise.reject("".concat(e, " is not a File"));
  var t = je(r);
  return Promise.resolve(t);
}
function Wt(e) {
  return ge(this, void 0, void 0, function() {
    return be(this, function(r) {
      return [2, e.isDirectory ? Mr(e) : Yt(e)];
    });
  });
}
function Mr(e) {
  var r = e.createReader();
  return new Promise(function(t, n) {
    var i = [];
    function o() {
      var s = this;
      r.readEntries(function(c) {
        return ge(s, void 0, void 0, function() {
          var v, f, y;
          return be(this, function(h) {
            switch (h.label) {
              case 0:
                if (c.length) return [3, 5];
                h.label = 1;
              case 1:
                return h.trys.push([1, 3, , 4]), [4, Promise.all(i)];
              case 2:
                return v = h.sent(), t(v), [3, 4];
              case 3:
                return f = h.sent(), n(f), [3, 4];
              case 4:
                return [3, 6];
              case 5:
                y = Promise.all(c.map(Wt)), i.push(y), o(), h.label = 6;
              case 6:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, function(c) {
        n(c);
      });
    }
    o();
  });
}
function Yt(e) {
  return ge(this, void 0, void 0, function() {
    return be(this, function(r) {
      return [2, new Promise(function(t, n) {
        e.file(function(i) {
          var o = je(i, e.fullPath);
          t(o);
        }, function(i) {
          n(i);
        });
      })];
    });
  });
}
var qt = function(e, r) {
  if (e && r) {
    var t = Array.isArray(r) ? r : r.split(","), n = e.name || "", i = (e.type || "").toLowerCase(), o = i.replace(/\/.*$/, "");
    return t.some(function(s) {
      var c = s.trim().toLowerCase();
      return c.charAt(0) === "." ? n.toLowerCase().endsWith(c) : c.endsWith("/*") ? o === c.replace(/\/.*$/, "") : i === c;
    });
  }
  return !0;
};
function wr(e) {
  return Ht(e) || Kt(e) || $r(e) || Bt();
}
function Bt() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Kt(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function Ht(e) {
  if (Array.isArray(e)) return Ze(e);
}
function jr(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    r && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function Tr(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? jr(Object(t), !0).forEach(function(n) {
      kr(e, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : jr(Object(t)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return e;
}
function kr(e, r, t) {
  return r in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function we(e, r) {
  return Jt(e) || Gt(e, r) || $r(e, r) || Vt();
}
function Vt() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function $r(e, r) {
  if (e) {
    if (typeof e == "string") return Ze(e, r);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return Ze(e, r);
  }
}
function Ze(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var t = 0, n = new Array(r); t < r; t++)
    n[t] = e[t];
  return n;
}
function Gt(e, r) {
  var t = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t != null) {
    var n = [], i = !0, o = !1, s, c;
    try {
      for (t = t.call(e); !(i = (s = t.next()).done) && (n.push(s.value), !(r && n.length === r)); i = !0)
        ;
    } catch (v) {
      o = !0, c = v;
    } finally {
      try {
        !i && t.return != null && t.return();
      } finally {
        if (o) throw c;
      }
    }
    return n;
  }
}
function Jt(e) {
  if (Array.isArray(e)) return e;
}
var Nr = "file-invalid-type", Ur = "file-too-large", Lr = "file-too-small", Wr = "too-many-files", co = {
  FileInvalidType: Nr,
  FileTooLarge: Ur,
  FileTooSmall: Lr,
  TooManyFiles: Wr
}, Xt = function(r) {
  r = Array.isArray(r) && r.length === 1 ? r[0] : r;
  var t = Array.isArray(r) ? "one of ".concat(r.join(", ")) : r;
  return {
    code: Nr,
    message: "File type must be ".concat(t)
  };
}, Or = function(r) {
  return {
    code: Ur,
    message: "File is larger than ".concat(r, " ").concat(r === 1 ? "byte" : "bytes")
  };
}, Sr = function(r) {
  return {
    code: Lr,
    message: "File is smaller than ".concat(r, " ").concat(r === 1 ? "byte" : "bytes")
  };
}, Zt = {
  code: Wr,
  message: "Too many files"
};
function Yr(e, r) {
  var t = e.type === "application/x-moz-file" || qt(e, r);
  return [t, t ? null : Xt(r)];
}
function qr(e, r, t) {
  if (le(e.size))
    if (le(r) && le(t)) {
      if (e.size > t) return [!1, Or(t)];
      if (e.size < r) return [!1, Sr(r)];
    } else {
      if (le(r) && e.size < r) return [!1, Sr(r)];
      if (le(t) && e.size > t) return [!1, Or(t)];
    }
  return [!0, null];
}
function le(e) {
  return e != null;
}
function Qt(e) {
  var r = e.files, t = e.accept, n = e.minSize, i = e.maxSize, o = e.multiple, s = e.maxFiles, c = e.validator;
  return !o && r.length > 1 || o && s >= 1 && r.length > s ? !1 : r.every(function(v) {
    var f = Yr(v, t), y = we(f, 1), h = y[0], C = qr(v, n, i), R = we(C, 1), $ = R[0], D = c ? c(v) : null;
    return h && $ && !D;
  });
}
function Ce(e) {
  return typeof e.isPropagationStopped == "function" ? e.isPropagationStopped() : typeof e.cancelBubble < "u" ? e.cancelBubble : !1;
}
function _e(e) {
  return e.dataTransfer ? Array.prototype.some.call(e.dataTransfer.types, function(r) {
    return r === "Files" || r === "application/x-moz-file";
  }) : !!e.target && !!e.target.files;
}
function Ar(e) {
  e.preventDefault();
}
function en(e) {
  return e.indexOf("MSIE") !== -1 || e.indexOf("Trident/") !== -1;
}
function rn(e) {
  return e.indexOf("Edge/") !== -1;
}
function tn() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.navigator.userAgent;
  return en(e) || rn(e);
}
function oe() {
  for (var e = arguments.length, r = new Array(e), t = 0; t < e; t++)
    r[t] = arguments[t];
  return function(n) {
    for (var i = arguments.length, o = new Array(i > 1 ? i - 1 : 0), s = 1; s < i; s++)
      o[s - 1] = arguments[s];
    return r.some(function(c) {
      return !Ce(n) && c && c.apply(void 0, [n].concat(o)), Ce(n);
    });
  };
}
function nn() {
  return "showOpenFilePicker" in window;
}
function on(e) {
  if (le(e)) {
    var r = Object.entries(e).filter(function(t) {
      var n = we(t, 2), i = n[0], o = n[1], s = !0;
      return Br(i) || (console.warn('Skipped "'.concat(i, '" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types.')), s = !1), (!Array.isArray(o) || !o.every(Kr)) && (console.warn('Skipped "'.concat(i, '" because an invalid file extension was provided.')), s = !1), s;
    }).reduce(function(t, n) {
      var i = we(n, 2), o = i[0], s = i[1];
      return Tr(Tr({}, t), {}, kr({}, o, s));
    }, {});
    return [{
      // description is required due to https://crbug.com/1264708
      description: "Files",
      accept: r
    }];
  }
  return e;
}
function an(e) {
  if (le(e))
    return Object.entries(e).reduce(function(r, t) {
      var n = we(t, 2), i = n[0], o = n[1];
      return [].concat(wr(r), [i], wr(o));
    }, []).filter(function(r) {
      return Br(r) || Kr(r);
    }).join(",");
}
function cn(e) {
  return e instanceof DOMException && (e.name === "AbortError" || e.code === e.ABORT_ERR);
}
function sn(e) {
  return e instanceof DOMException && (e.name === "SecurityError" || e.code === e.SECURITY_ERR);
}
function Br(e) {
  return e === "audio/*" || e === "video/*" || e === "image/*" || e === "text/*" || /\w+\/[-+.\w]+/g.test(e);
}
function Kr(e) {
  return /^.*\.[\w]+$/.test(e);
}
var un = ["children"], ln = ["open"], fn = ["refKey", "role", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"], pn = ["refKey", "onChange", "onClick"];
function dn(e) {
  return yn(e) || vn(e) || Hr(e) || mn();
}
function mn() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function vn(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function yn(e) {
  if (Array.isArray(e)) return Qe(e);
}
function Ge(e, r) {
  return hn(e) || bn(e, r) || Hr(e, r) || gn();
}
function gn() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Hr(e, r) {
  if (e) {
    if (typeof e == "string") return Qe(e, r);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return Qe(e, r);
  }
}
function Qe(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var t = 0, n = new Array(r); t < r; t++)
    n[t] = e[t];
  return n;
}
function bn(e, r) {
  var t = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t != null) {
    var n = [], i = !0, o = !1, s, c;
    try {
      for (t = t.call(e); !(i = (s = t.next()).done) && (n.push(s.value), !(r && n.length === r)); i = !0)
        ;
    } catch (v) {
      o = !0, c = v;
    } finally {
      try {
        !i && t.return != null && t.return();
      } finally {
        if (o) throw c;
      }
    }
    return n;
  }
}
function hn(e) {
  if (Array.isArray(e)) return e;
}
function Dr(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    r && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function k(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? Dr(Object(t), !0).forEach(function(n) {
      er(e, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Dr(Object(t)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return e;
}
function er(e, r, t) {
  return r in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function Fe(e, r) {
  if (e == null) return {};
  var t = xn(e, r), n, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      n = o[i], !(r.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (t[n] = e[n]);
  }
  return t;
}
function xn(e, r) {
  if (e == null) return {};
  var t = {}, n = Object.keys(e), i, o;
  for (o = 0; o < n.length; o++)
    i = n[o], !(r.indexOf(i) >= 0) && (t[i] = e[i]);
  return t;
}
var ar = /* @__PURE__ */ it(function(e, r) {
  var t = e.children, n = Fe(e, un), i = Gr(n), o = i.open, s = Fe(i, ln);
  return at(r, function() {
    return {
      open: o
    };
  }, [o]), /* @__PURE__ */ nt.createElement(ct, null, t(k(k({}, s), {}, {
    open: o
  })));
});
ar.displayName = "Dropzone";
var Vr = {
  disabled: !1,
  getFilesFromEvent: zt,
  maxSize: 1 / 0,
  minSize: 0,
  multiple: !0,
  maxFiles: 0,
  preventDropOnDocument: !0,
  noClick: !1,
  noKeyboard: !1,
  noDrag: !1,
  noDragEventsBubbling: !1,
  validator: null,
  useFsAccessApi: !0,
  autoFocus: !1
};
ar.defaultProps = Vr;
ar.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */
  children: F.func,
  /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */
  accept: F.objectOf(F.arrayOf(F.string)),
  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: F.bool,
  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: F.bool,
  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: F.bool,
  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: F.bool,
  /**
   * If true, disables drag 'n' drop
   */
  noDrag: F.bool,
  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: F.bool,
  /**
   * Minimum file size (in bytes)
   */
  minSize: F.number,
  /**
   * Maximum file size (in bytes)
   */
  maxSize: F.number,
  /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */
  maxFiles: F.number,
  /**
   * Enable/disable the dropzone
   */
  disabled: F.bool,
  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: F.func,
  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: F.func,
  /**
   * Cb for when opening the file dialog
   */
  onFileDialogOpen: F.func,
  /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */
  useFsAccessApi: F.bool,
  /**
   * Set to true to focus the root element on render
   */
  autoFocus: F.bool,
  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: F.func,
  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: F.func,
  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: F.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: F.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: F.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: F.func,
  /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */
  onError: F.func,
  /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */
  validator: F.func
};
var rr = {
  isFocused: !1,
  isFileDialogActive: !1,
  isDragActive: !1,
  isDragAccept: !1,
  isDragReject: !1,
  acceptedFiles: [],
  fileRejections: []
};
function Gr() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = k(k({}, Vr), e), t = r.accept, n = r.disabled, i = r.getFilesFromEvent, o = r.maxSize, s = r.minSize, c = r.multiple, v = r.maxFiles, f = r.onDragEnter, y = r.onDragLeave, h = r.onDragOver, C = r.onDrop, R = r.onDropAccepted, $ = r.onDropRejected, D = r.onFileDialogCancel, N = r.onFileDialogOpen, K = r.useFsAccessApi, te = r.autoFocus, z = r.preventDropOnDocument, M = r.noClick, p = r.noKeyboard, X = r.noDrag, Y = r.noDragEventsBubbling, ie = r.onError, Q = r.validator, ee = me(function() {
    return an(t);
  }, [t]), ae = me(function() {
    return on(t);
  }, [t]), ce = me(function() {
    return typeof N == "function" ? N : _r;
  }, [N]), ne = me(function() {
    return typeof D == "function" ? D : _r;
  }, [D]), I = Ae(null), q = Ae(null), V = ot(En, rr), B = Ge(V, 2), re = B[0], L = B[1], a = re.isFocused, m = re.isFileDialogActive, E = Ae(typeof window < "u" && window.isSecureContext && K && nn()), w = function() {
    !E.current && m && setTimeout(function() {
      if (q.current) {
        var g = q.current.files;
        g.length || (L({
          type: "closeDialog"
        }), ne());
      }
    }, 300);
  };
  We(function() {
    return window.addEventListener("focus", w, !1), function() {
      window.removeEventListener("focus", w, !1);
    };
  }, [q, m, ne, E]);
  var b = Ae([]), O = function(g) {
    I.current && I.current.contains(g.target) || (g.preventDefault(), b.current = []);
  };
  We(function() {
    return z && (document.addEventListener("dragover", Ar, !1), document.addEventListener("drop", O, !1)), function() {
      z && (document.removeEventListener("dragover", Ar), document.removeEventListener("drop", O));
    };
  }, [I, z]), We(function() {
    return !n && te && I.current && I.current.focus(), function() {
    };
  }, [I, te, n]);
  var x = Z(function(d) {
    ie ? ie(d) : console.error(d);
  }, [ie]), j = Z(function(d) {
    d.preventDefault(), d.persist(), Oe(d), b.current = [].concat(dn(b.current), [d.target]), _e(d) && Promise.resolve(i(d)).then(function(g) {
      if (!(Ce(d) && !Y)) {
        var U = g.length, H = U > 0 && Qt({
          files: g,
          accept: ee,
          minSize: s,
          maxSize: o,
          multiple: c,
          maxFiles: v,
          validator: Q
        }), J = U > 0 && !H;
        L({
          isDragAccept: H,
          isDragReject: J,
          isDragActive: !0,
          type: "setDraggedFiles"
        }), f && f(d);
      }
    }).catch(function(g) {
      return x(g);
    });
  }, [i, f, x, Y, ee, s, o, c, v, Q]), S = Z(function(d) {
    d.preventDefault(), d.persist(), Oe(d);
    var g = _e(d);
    if (g && d.dataTransfer)
      try {
        d.dataTransfer.dropEffect = "copy";
      } catch {
      }
    return g && h && h(d), !1;
  }, [h, Y]), A = Z(function(d) {
    d.preventDefault(), d.persist(), Oe(d);
    var g = b.current.filter(function(H) {
      return I.current && I.current.contains(H);
    }), U = g.indexOf(d.target);
    U !== -1 && g.splice(U, 1), b.current = g, !(g.length > 0) && (L({
      type: "setDraggedFiles",
      isDragActive: !1,
      isDragAccept: !1,
      isDragReject: !1
    }), _e(d) && y && y(d));
  }, [I, y, Y]), T = Z(function(d, g) {
    var U = [], H = [];
    d.forEach(function(J) {
      var xe = Yr(J, ee), de = Ge(xe, 2), ze = de[0], Me = de[1], ke = qr(J, s, o), Se = Ge(ke, 2), $e = Se[0], Ne = Se[1], Ue = Q ? Q(J) : null;
      if (ze && $e && !Ue)
        U.push(J);
      else {
        var Le = [Me, Ne];
        Ue && (Le = Le.concat(Ue)), H.push({
          file: J,
          errors: Le.filter(function(tt) {
            return tt;
          })
        });
      }
    }), (!c && U.length > 1 || c && v >= 1 && U.length > v) && (U.forEach(function(J) {
      H.push({
        file: J,
        errors: [Zt]
      });
    }), U.splice(0)), L({
      acceptedFiles: U,
      fileRejections: H,
      type: "setFiles"
    }), C && C(U, H, g), H.length > 0 && $ && $(H, g), U.length > 0 && R && R(U, g);
  }, [L, c, ee, s, o, v, C, R, $, Q]), W = Z(function(d) {
    d.preventDefault(), d.persist(), Oe(d), b.current = [], _e(d) && Promise.resolve(i(d)).then(function(g) {
      Ce(d) && !Y || T(g, d);
    }).catch(function(g) {
      return x(g);
    }), L({
      type: "reset"
    });
  }, [i, T, x, Y]), u = Z(function() {
    if (E.current) {
      L({
        type: "openDialog"
      }), ce();
      var d = {
        multiple: c,
        types: ae
      };
      window.showOpenFilePicker(d).then(function(g) {
        return i(g);
      }).then(function(g) {
        T(g, null), L({
          type: "closeDialog"
        });
      }).catch(function(g) {
        cn(g) ? (ne(g), L({
          type: "closeDialog"
        })) : sn(g) ? (E.current = !1, q.current ? (q.current.value = null, q.current.click()) : x(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."))) : x(g);
      });
      return;
    }
    q.current && (L({
      type: "openDialog"
    }), ce(), q.current.value = null, q.current.click());
  }, [L, ce, ne, K, T, x, ae, c]), G = Z(function(d) {
    !I.current || !I.current.isEqualNode(d.target) || (d.key === " " || d.key === "Enter" || d.keyCode === 32 || d.keyCode === 13) && (d.preventDefault(), u());
  }, [I, u]), ue = Z(function() {
    L({
      type: "focus"
    });
  }, []), he = Z(function() {
    L({
      type: "blur"
    });
  }, []), sr = Z(function() {
    M || (tn() ? setTimeout(u, 0) : u());
  }, [M, u]), pe = function(g) {
    return n ? null : g;
  }, Ie = function(g) {
    return p ? null : pe(g);
  }, Te = function(g) {
    return X ? null : pe(g);
  }, Oe = function(g) {
    Y && g.stopPropagation();
  }, Qr = me(function() {
    return function() {
      var d = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, g = d.refKey, U = g === void 0 ? "ref" : g, H = d.role, J = d.onKeyDown, xe = d.onFocus, de = d.onBlur, ze = d.onClick, Me = d.onDragEnter, ke = d.onDragOver, Se = d.onDragLeave, $e = d.onDrop, Ne = Fe(d, fn);
      return k(k(er({
        onKeyDown: Ie(oe(J, G)),
        onFocus: Ie(oe(xe, ue)),
        onBlur: Ie(oe(de, he)),
        onClick: pe(oe(ze, sr)),
        onDragEnter: Te(oe(Me, j)),
        onDragOver: Te(oe(ke, S)),
        onDragLeave: Te(oe(Se, A)),
        onDrop: Te(oe($e, W)),
        role: typeof H == "string" && H !== "" ? H : "presentation"
      }, U, I), !n && !p ? {
        tabIndex: 0
      } : {}), Ne);
    };
  }, [I, G, ue, he, sr, j, S, A, W, p, X, n]), et = Z(function(d) {
    d.stopPropagation();
  }, []), rt = me(function() {
    return function() {
      var d = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, g = d.refKey, U = g === void 0 ? "ref" : g, H = d.onChange, J = d.onClick, xe = Fe(d, pn), de = er({
        accept: ee,
        multiple: c,
        type: "file",
        style: {
          display: "none"
        },
        onChange: pe(oe(H, W)),
        onClick: pe(oe(J, et)),
        tabIndex: -1
      }, U, q);
      return k(k({}, de), xe);
    };
  }, [q, t, c, W, n]);
  return k(k({}, re), {}, {
    isFocused: a && !n,
    getRootProps: Qr,
    getInputProps: rt,
    rootRef: I,
    inputRef: q,
    open: pe(u)
  });
}
function En(e, r) {
  switch (r.type) {
    case "focus":
      return k(k({}, e), {}, {
        isFocused: !0
      });
    case "blur":
      return k(k({}, e), {}, {
        isFocused: !1
      });
    case "openDialog":
      return k(k({}, rr), {}, {
        isFileDialogActive: !0
      });
    case "closeDialog":
      return k(k({}, e), {}, {
        isFileDialogActive: !1
      });
    case "setDraggedFiles":
      return k(k({}, e), {}, {
        isDragActive: r.isDragActive,
        isDragAccept: r.isDragAccept,
        isDragReject: r.isDragReject
      });
    case "setFiles":
      return k(k({}, e), {}, {
        acceptedFiles: r.acceptedFiles,
        fileRejections: r.fileRejections
      });
    case "reset":
      return k({}, rr);
    default:
      return e;
  }
}
function _r() {
}
const Jr = ({ icon: e, size: r }) => /* @__PURE__ */ l.jsx(ft, { icon: e, size: r }), wn = fe({
  base: "cur-px-2 cur-text-center",
  variants: {
    disabled: {
      true: "cur-text-disabled",
      false: "cur-text-subtle"
    }
  }
}), Xr = ({ children: e, disabled: r, id: t }) => /* @__PURE__ */ l.jsx(
  ve,
  {
    as: "label",
    htmlFor: t,
    size: "meta",
    className: wn({ disabled: r }),
    children: e
  }
), cr = ({ children: e, className: r, id: t }) => /* @__PURE__ */ l.jsx(
  ve,
  {
    as: "label",
    htmlFor: t,
    size: "meta",
    weight: "bold",
    className: ye("cur-relative cur-z-10 cur-w-full cur-p-3", r),
    children: e
  }
), jn = fe({
  base: "cur-flex cur-items-center cur-justify-center cur-rounded-full",
  variants: {
    large: {
      true: "cur-h-12 cur-w-12",
      false: "cur-h-10 cur-w-10"
    }
  }
}), Re = ({ children: e, className: r, large: t = !1 }) => /* @__PURE__ */ l.jsx(
  "div",
  {
    className: jn({ large: t, className: r }),
    children: e
  }
), Tn = ({ children: e, className: r }) => /* @__PURE__ */ l.jsx("div", { className: ye("cur-relative cur-z-10 cur-grow", r), children: e }), Zr = ({ children: e, className: r }) => /* @__PURE__ */ l.jsx("div", { className: ye("cur-w-full cur-px-3 cur-py-2", r), children: e }), Ee = ({ active: e = !1, children: r }) => e ? /* @__PURE__ */ l.jsx(l.Fragment, { children: r }) : null, se = ({
  children: e,
  className: r
}) => /* @__PURE__ */ l.jsx(pt, { initial: !1, children: /* @__PURE__ */ l.jsx(
  dt.div,
  {
    className: ye(
      "cur-absolute cur-left-0 cur-top-0 cur-flex cur-h-full cur-w-full cur-flex-col cur-gap-3 cur-transition-all",
      r
    ),
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
    transition: { duration: 0.1 },
    children: e
  }
) }), On = ({ disabled: e, icon: r = or, iconSize: t, id: n, maxFiles: i, text: o }) => /* @__PURE__ */ l.jsxs(se, { className: "cur-cursor-pointer cur-items-center cur-justify-center", children: [
  /* @__PURE__ */ l.jsx(Jr, { size: t || "xxl", icon: r }),
  /* @__PURE__ */ l.jsx(Xr, { disabled: e, id: n, children: o || `Select or drop file${i === 1 ? "" : "s"} here` })
] }), Sn = ({ disabled: e, id: r }) => /* @__PURE__ */ l.jsxs(se, { className: "cur-items-center cur-justify-center", children: [
  /* @__PURE__ */ l.jsx(
    Re,
    {
      className: "cur-bg-brand cur-text-white",
      large: !0,
      children: /* @__PURE__ */ l.jsx(mt, { size: "sm", className: "cur-rotate-90" })
    }
  ),
  /* @__PURE__ */ l.jsx(Xr, { id: r, disabled: e, children: "Drop" })
] }), An = ({ className: e, percentage: r }) => /* @__PURE__ */ l.jsx(
  "div",
  {
    className: ye(
      "cur-relative -cur-z-10 cur-h-full cur-w-full cur-bg-surface-highlight",
      e
    ),
    children: r !== null ? /* @__PURE__ */ l.jsxs(
      ve,
      {
        className: "cur-absolute cur-bottom-3 cur-left-3 cur-text-subtle",
        size: "meta",
        children: [
          Math.floor(r),
          "%"
        ]
      }
    ) : null
  }
), Pr = (e) => /* @__PURE__ */ l.jsx(An, { percentage: e }), Cr = {
  className: "cur-w-full cur-grow",
  size: "lg",
  track: !1
}, Dn = ({ id: e, progress: r }) => /* @__PURE__ */ l.jsxs(se, { className: "cur-z-10 cur-cursor-wait cur-items-center cur-justify-center", children: [
  /* @__PURE__ */ l.jsx(cr, { id: e, className: "cur-text-brand", children: "Uploading..." }),
  /* @__PURE__ */ l.jsx(Tn, { children: /* @__PURE__ */ l.jsx(Jr, { size: "xl", icon: or }) }),
  /* @__PURE__ */ l.jsx("div", { className: "cur-absolute cur-left-0 cur-top-0 cur-z-0 cur-flex cur-h-full cur-w-full cur-flex-col cur-justify-end", children: r === void 0 ? /* @__PURE__ */ l.jsx(vt, { ...Cr, children: Pr }) : /* @__PURE__ */ l.jsx(yt, { ...Cr, max: 100, value: r, children: Pr }) })
] }), _n = ({ completeAction: e, id: r }) => /* @__PURE__ */ l.jsxs(se, { className: "cur-z-10 cur-items-center cur-justify-center cur-bg-surface-highlight", children: [
  /* @__PURE__ */ l.jsx(cr, { id: r, className: "cur-text-brand", children: "Complete" }),
  /* @__PURE__ */ l.jsx("div", { className: "cur-relative cur-z-10 cur-grow", children: /* @__PURE__ */ l.jsx(Re, { className: "cur-bg-brand cur-text-white", children: /* @__PURE__ */ l.jsx(bt, { size: "sm" }) }) }),
  /* @__PURE__ */ l.jsx(Zr, { className: "cur-bg-brand", children: e })
] }), Pn = ({ errorAction: e, id: r, message: t }) => /* @__PURE__ */ l.jsxs(
  se,
  {
    className: "cur-z-10 cur-items-center cur-justify-center cur-bg-surface-error",
    id: `${r}-error`,
    children: [
      /* @__PURE__ */ l.jsxs(cr, { id: r, className: "cur-text-error", children: [
        "Error",
        t ? `: ${t}` : ""
      ] }),
      /* @__PURE__ */ l.jsx("div", { className: "cur-relative cur-z-10 cur-grow", children: /* @__PURE__ */ l.jsx(Re, { className: "cur-bg-surface-error-bold cur-text-white", children: /* @__PURE__ */ l.jsx(Fr, { size: "sm" }) }) }),
      /* @__PURE__ */ l.jsx(Zr, { className: "cur-bg-surface-error-bold", children: e })
    ]
  }
), Cn = {
  "image/gif": [".gif"],
  "image/heic": [".heic", ".heif"],
  "image/heif": [".heic", ".heif"],
  "image/jpeg": [".jpg", ".jpeg", ".heic"],
  "image/png": [".png"],
  "image/tiff": [".tiff", ".tif"],
  "image/webp": [".webp"]
}, Fn = fe({
  variants: {
    disabled: {
      true: "cur-text-disabled",
      false: "cur-text-surface-brand-accent"
    }
  }
}), Rn = ({ disabled: e }) => /* @__PURE__ */ l.jsx(wt, { className: Fn({ disabled: e }), size: "xxl" }), In = ({ icon: e, id: r, progress: t }) => {
  const n = gt(!1), i = Math.round(
    t !== void 0 ? t : n * 100
  );
  return /* @__PURE__ */ l.jsx(se, { className: "cur-z-10 cur-cursor-wait cur-items-center cur-justify-center cur-overflow-hidden cur-text-brand", children: /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    e,
    /* @__PURE__ */ l.jsx(
      Et,
      {
        id: "testing",
        progress: i,
        className: "cur-absolute cur-left-0 cur-z-10 cur-origin-top cur-scale-150",
        children: /* @__PURE__ */ l.jsxs(
          "label",
          {
            className: "cur-absolute cur-bottom-2 cur-left-2 cur-z-20 cur-text-inverse",
            htmlFor: r,
            children: [
              /* @__PURE__ */ l.jsx(ve, { size: "meta", weight: "bold", children: "Uploading..." }),
              /* @__PURE__ */ l.jsxs(ve, { size: "meta", children: [
                i,
                "%"
              ] })
            ]
          }
        )
      }
    )
  ] }) });
}, zn = ({ id: e, message: r }) => /* @__PURE__ */ l.jsxs(
  se,
  {
    className: "cur-z-10 cur-items-center cur-justify-center cur-border-4 cur-border-border-error cur-bg-surface-error",
    id: `${e}-error`,
    children: [
      /* @__PURE__ */ l.jsxs("div", { className: "cur-hidden", children: [
        "Error",
        r ? `: ${r}` : ""
      ] }),
      /* @__PURE__ */ l.jsx("div", { className: "cur-relative cur-z-10 cur-flex cur-grow cur-items-center", children: /* @__PURE__ */ l.jsx(Re, { className: "cur-bg-surface-error-bold cur-text-white", children: /* @__PURE__ */ l.jsx(Fr, { size: "sm" }) }) })
    ]
  }
), Mn = ({ completeAction: e }) => /* @__PURE__ */ l.jsx(se, { className: "cur-z-30 cur-items-end cur-justify-end", children: e }), kn = fe({
  base: "cur-absolute cur-top-0 cur-left-0 cur-z-40 cur-h-full cur-w-full cur-border-4 cur-pointer-events-none",
  variants: {
    disabled: {
      true: "cur-border-border-disabled",
      false: "cur-border-border-brand"
    }
  }
}), $n = fe({
  base: "-cur-m-4",
  variants: {
    disabled: {
      true: "cur-grayscale"
    },
    imageOverflowHidden: {
      true: "cur-overflow-hidden"
    }
  }
}), so = tr(
  "ImageUpload",
  nr(
    ({
      accept: e = Cn,
      aspectRatio: r = "3:4",
      imageOverflowHidden: t = !1,
      className: n,
      disabled: i,
      icon: o = /* @__PURE__ */ l.jsx(Rn, { disabled: i }),
      iconSize: s,
      src: c,
      ...v
    }, f) => /* @__PURE__ */ l.jsx(
      Ln,
      {
        ...v,
        accept: e,
        className: ht({ aspectRatio: r, className: n }),
        completeState: Mn,
        disabled: i,
        errorState: zn,
        icon: o,
        iconSize: s,
        maxFiles: 1,
        multiple: !1,
        ref: f,
        uploadingState: In,
        children: c ? /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
          /* @__PURE__ */ l.jsx(
            xt,
            {
              className: $n({ disabled: i, imageOverflowHidden: t }),
              aspectRatio: r,
              src: c
            }
          ),
          /* @__PURE__ */ l.jsx("div", { className: kn({ disabled: i }) })
        ] }) : null
      }
    )
  )
), Nn = fe({
  base: "cur-h-[8rem] cur-flex cur-justify-center cur-items-center cur-flex-col cur-gap-3 cur-relative cur-group cur-bg-surface-neutral cur-p-4 cur-box-content",
  variants: {
    disabled: {
      true: null
    },
    uploading: {
      true: null
    }
  },
  compoundVariants: [
    {
      disabled: !1,
      uploading: !1,
      className: "hover:cur-bg-surface-neutral-hover"
    }
  ]
}), Un = fe({
  base: "cur-absolute cur-left-0 cur-top-0 cur-z-0 cur-h-full cur-w-full cur-border-4 cur-border-dashed cur-transition-all",
  variants: {
    disabled: {
      true: "cur-border-border-disabled",
      false: "cur-border-border-brand-light"
    },
    uploading: {
      true: null
    }
  },
  compoundVariants: [
    {
      disabled: !1,
      uploading: !1,
      className: "group-hover:cur-border-border-brand-hover"
    }
  ]
}), Ln = tr(
  "FileUpload",
  nr(
    ({
      accept: e,
      as: r,
      autoFocus: t,
      children: n,
      className: i,
      complete: o = !1,
      completeAction: s = null,
      disabled: c = !1,
      error: v,
      errorAction: f = null,
      icon: y = or,
      iconSize: h,
      id: C,
      initialLabel: R,
      maxFiles: $ = 1,
      maxSize: D,
      minSize: N,
      multiple: K = !1,
      name: te,
      onError: z,
      onFileAdded: M,
      onFileRejected: p,
      progress: X,
      uploading: Y = !1,
      validator: ie,
      completeState: Q = _n,
      dropState: ee = Sn,
      errorState: ae = Pn,
      initialState: ce = On,
      uploadingState: ne = Dn,
      ...I
    }, q) => {
      const V = r || "div", B = ut("file-upload", C), { isDragActive: re, getRootProps: L, getInputProps: a } = Gr({
        accept: e,
        autoFocus: t,
        disabled: c || Y || o,
        maxFiles: $,
        maxSize: D,
        minSize: N,
        multiple: K,
        onDropAccepted: M,
        onDropRejected: p,
        onError: z,
        validator: ie
      });
      return /* @__PURE__ */ l.jsx(lt, { children: /* @__PURE__ */ l.jsxs(
        V,
        {
          ref: q,
          "aria-invalid": v ? !0 : void 0,
          "aria-errormessage": v ? `${B}-error` : void 0,
          ...L({
            className: Nn({
              className: i,
              disabled: c,
              uploading: Y
            })
          }),
          ...I,
          children: [
            /* @__PURE__ */ l.jsx(
              Ee,
              {
                active: !v && !o && !Y && !re,
                children: /* @__PURE__ */ l.jsx(
                  ce,
                  {
                    disabled: c,
                    icon: y,
                    iconSize: h,
                    id: B,
                    maxFiles: $,
                    text: R
                  }
                )
              }
            ),
            /* @__PURE__ */ l.jsx(
              Ee,
              {
                active: !v && !o && !Y && re,
                children: /* @__PURE__ */ l.jsx(ee, { disabled: c, id: B })
              }
            ),
            /* @__PURE__ */ l.jsx(Ee, { active: !v && !o && Y, children: /* @__PURE__ */ l.jsx(ne, { id: B, progress: X, icon: y }) }),
            /* @__PURE__ */ l.jsx(Ee, { active: o, children: /* @__PURE__ */ l.jsx(Q, { completeAction: s, id: B }) }),
            /* @__PURE__ */ l.jsx(Ee, { active: !!v, children: /* @__PURE__ */ l.jsx(
              ae,
              {
                errorAction: f,
                id: B,
                message: v == null ? void 0 : v.message
              }
            ) }),
            n,
            /* @__PURE__ */ l.jsx("input", { id: B, ...a(), name: te }),
            /* @__PURE__ */ l.jsx(
              "div",
              {
                className: Un({ disabled: c, uploading: Y })
              }
            )
          ]
        }
      ) });
    }
  )
), uo = tr(
  "FileUploadAction",
  nr(
    ({ as: e = "a", children: r, className: t, ...n }, i) => /* @__PURE__ */ l.jsx(
      ve,
      {
        className: ye(
          "cur-cursor-pointer cur-text-inverse cur-underline hover:cur-no-underline",
          t
        ),
        size: "meta",
        as: e,
        ref: i,
        ...n,
        children: r
      }
    )
  )
);
export {
  co as E,
  Ln as F,
  so as I,
  uo as a,
  zn as b
};
//# sourceMappingURL=index-DG7OKFQx.js.map
